import React from "react";
import { NavLink } from "react-router-dom";
import { ArrowLeftRight, LogOut } from "lucide-react";
import { cn } from "../lib/utils";

function prettyLabel(label) {
  if (!label) return "";
  const first = label.split(" ")[0] || label;
  return first.charAt(0) + first.slice(1).toLowerCase();
}

const dockItemClass =
  "flex min-h-[52px] min-w-0 flex-1 flex-col items-center justify-center gap-0.5 rounded-xl px-1 text-[var(--t-meta)] transition-colors";

/** Frosted top dock for portal / engagement workspace (mobile + tablet). */
export function PortalMobileTopNav({
  items,
  isAdmin,
  onStudio,
  onLogout,
}) {
  return (
    <div
      className="mx-3 mb-1 mt-2 rounded-2xl border border-white/50 bg-[rgba(236,241,250,0.88)] px-2 py-2 shadow-none backdrop-blur-md sm:mx-4"
      data-testid="mobile-top-nav"
    >
      <div className="flex items-end justify-around gap-0.5">
        {items.slice(0, 5).map(({ to, label, icon: Icon, end, testid }) => (
          <NavLink
            key={to || "home"}
            to={to}
            end={end}
            className={({ isActive }) =>
              cn(
                dockItemClass,
                isActive
                  ? "bg-[var(--t-accent)]/10 text-[var(--t-accent)]"
                  : "text-[var(--t-meta)]",
              )
            }
            data-testid={`mobile-${testid}`}
          >
            {({ isActive }) => (
              <>
                <Icon size={18} strokeWidth={1.4} />
                {isActive ? (
                  <span className="text-[9px] uppercase tracking-[0.12em]">
                    {prettyLabel(label)}
                  </span>
                ) : (
                  <span className="h-[11px]" aria-hidden />
                )}
              </>
            )}
          </NavLink>
        ))}
        {isAdmin ? (
          <button
            type="button"
            onClick={onStudio}
            className={dockItemClass}
            aria-label="Studio"
            data-testid="back-to-admin-btn-mobile"
          >
            <ArrowLeftRight size={18} strokeWidth={1.4} />
            <span className="h-[11px]" aria-hidden />
          </button>
        ) : null}
        <button
          type="button"
          onClick={onLogout}
          className={dockItemClass}
          aria-label="Sign out"
          data-testid="logout-btn-mobile"
        >
          <LogOut size={18} strokeWidth={1.4} />
          <span className="h-[11px]" aria-hidden />
        </button>
      </div>
    </div>
  );
}
